export const environment = {
  production: true,
  reliance: false,
  customer: '', // options: jiomart, vf
  relianceCustomers: {
    jiomart: { label: 'Jiomart', url: 'https://shipsy-wms-be.ril.com/' },
    vf: { label: 'VF', url: 'https://vf-wms-be.ril.com/' },
    jmqc: { label: 'QC', url: 'https://qc-wms-be.ril.com/' }, // jiomart quick commerce
  } as Record<string, { label: string; url: string }>,
  liveUpdateChannel: 'reliance',
  web_version: '', // stamped by `npm run build:reliance`; keep '' here
  web_version_code: 1793771582711, // stamped from the tag (3.81.2 -> 3081002); 0 disables the check, keep 0 here
  platform: 'capacitor'
};

/**
 * Returns the active Reliance customer's prod URL, or undefined if reliance is off.
 * Falls back to the first entry in the map if the configured customer key is missing,
 * so a misconfigured build still boots.
 */
export function getRelianceCustomerUrl(): string | undefined {
  if (!environment.reliance) {
    return undefined;
  }
  const map = environment.relianceCustomers ?? {};
  const key = environment.customer;
  return map[key]?.url ?? Object.values(map)[0]?.url;
}
